import { DocumentationLegacyPageBlockText, } from "./SDKDocumentationLegacyPageBlockText";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockHeading extends DocumentationLegacyPageBlockText {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.headingType = model.headingType;
    }
}
